export const EVENT_PAGE_CHANGE_CLICKED = 'jobs-view-page-change-clicked';
